import { render, staticRenderFns } from "./MockJs.vue?vue&type=template&id=556c652d"
import script from "./MockJs.vue?vue&type=script&lang=js"
export * from "./MockJs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports